import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import TagManagerService from "services/TagManager";
import PubSub from "services/PubSub/";
import style from './style.scss'; //NOSONAR

const Results = (props) => {
    const [isMobile, setMobile] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const search = props.search.toLowerCase();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            checkViewport();
            window.addEventListener("resize", checkViewport);
        }
        let findSuggestion = suggestions.find(item => {
            let itemSearch = '';
            if(typeof item === 'object'){
                itemSearch = item.label.toLowerCase();
            }else{
                itemSearch = item.toLowerCase();
            }
            return itemSearch.replace(/\s/g,'').includes(search.replace(/\s/g,''))
        });
        
        if(!findSuggestion){
            setNotFound(true);
        }else {
            setNotFound(false);
        }

        return function cleanup(){
            if (typeof window !== 'undefined') {
                window.removeEventListener("resize", checkViewport);
            }
        }
    });

    const checkViewport = ()  => {
        if(!document) return false;
        const $body = document.querySelector('body');
        const viewportWidth = $body.clientWidth;
        const currentIsMobile = viewportWidth <= 480;

        if(currentIsMobile !== isMobile){
            setMobile(currentIsMobile);
        }
    };

    const clickSearch = () => {
        PubSub.dispatch('search_redirect');

        TagManagerService.clickSearch('Search', search);
    };


    let categories = props.categories ? (isMobile ? props.categories.slice(0, 6) : props.categories) : [];

    categories.map(category => {
        category.name = category.name.replace(search + ' en ', '');
        return category;
    });

    const suggestions = props.suggestions ?  props.suggestions : [];
    const historySearch = props.historySearch ? props.historySearch : [];

    const ItemSuggestion = () => {
        return suggestions.map((suggestion, i) => {
            let termPosition = null;
            let searchTerm = ''
            if(typeof suggestion === 'object'){
                searchTerm = suggestion.label.toLowerCase();
            }else{
                searchTerm = suggestion.toLowerCase();
            }
            

            if(searchTerm.split(search)[0]){
                termPosition = <span className={'item'}>{(searchTerm.indexOf(search) !== -1) ? searchTerm.split(search)[0] : searchTerm}{(searchTerm.indexOf(search) !== -1) && <strong>{search}</strong>}{(searchTerm.indexOf(search) !== -1) && searchTerm.split(search).pop()}</span>;
            } else {
                termPosition = <span className={'item'}>{(searchTerm.indexOf(search) !== -1) && <strong>{search}</strong>}{(searchTerm.indexOf(search) !== -1) ? searchTerm.split(search) : searchTerm}</span>;
            }

            return (<li key={i} data-index={i} className={'item-suggestion' + ((props.position === i) ? ' active' : '')} onClick={() => props.setSearchItem(suggestion, i)}>
                {termPosition}
            </li>)
        });
    };


    return <div className={'header-search-autocomplete ' + (props.modalAutocomplete ? 'active' : '')} >
        <div className={'header-search-autocomplete-results' + (props.modalAutocomplete ? ' results-active' : '')}>
            {(notFound && suggestions.length && search.length) ? <span className={'recent-searchs'}>Quisiste decir:</span> : ''}
            {(search.length > 0 && !!suggestions.length) && <ul className={'suggestions-list'}>
                <ItemSuggestion/>
            </ul>}
            {((search.length === 0) && !suggestions.length && !!historySearch.length) &&<>
                <span className={'recent-searchs'}>Búsquedas recientes</span>
                <ul className={'search-history-list'}>
                    {historySearch.map((term, i) => {
                        return <li key={i} data-index={i} className={'item-history' + ((props.position === i) ? ' active' : '')}>
                            <span className={'item'}  onClick={() => props.setSearchItem(term, i)}>{(typeof term === 'object' ? term.label : term)}</span>
                            <span className={'remove'} onClick={() => props.removeHistory(i)}/>
                        </li>
                    })}
                </ul>
            </>}
            {(!props.isLoading && categories && (categories.length > 0) && (search.length > 0) && !!suggestions.length) && <ul className="header-search-categories">
                <span className={"header-search-categories-title"}>Buscar <strong>{search}</strong> en:</span>
                {categories.map((category, i) => {
                    const catUrl = category.href.split('https://jumbo.myvtex.com')[1].split('/').filter(Boolean);
                    const searchInput = catUrl.pop();
                    const searchUrl = `/${catUrl.join('/')}/?ft=${searchInput}`;

                    return (<li key={i} className="header-search-see-products-categories">
                        <Link to={searchUrl} onClick={clickSearch} className="header-search-link-products-categories">
                            {category.name}
                        </Link>
                    </li>)
                })}
            </ul>}
        </div>
    </div>
};

Results.propTypes = {
    isLoading: PropTypes.bool,
    search: PropTypes.string,
    modalAutocomplete: PropTypes.bool,
    products: PropTypes.array,
    categories: PropTypes.array,
    position: PropTypes.number,
    suggestions: PropTypes.array,
    historySearch: PropTypes.array,
    setSearchItem: PropTypes.func,
    removeHistory: PropTypes.func
};

export default Results;

